export default {
  root: {
    paddingTop: 0,
    paddingBottom: 0
  }
};
